/*
 * /patient/new (create page)
 */
import { Card, CardContent, CardHeader, CardTitle, Container, Page, PageHeader } from "@emr/react-ui"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import type { Patient } from "@emr/db/client"
import { PatientForm } from "../../features/patient/patient-form"

export const Route = createFileRoute("/patient/new")({
	component: NewPatientPage,
})

function NewPatientPage() {
	const navigate = useNavigate()

	function handleSuccess(patient: Patient) {
		navigate({ to: "/patient/$patientId", params: { patientId: patient.id } })
	}

	return (
		<Page>
			<Container width="xl" padding="lg" gap="lg">
				<PageHeader title="New Patient" />
				<Card>
					<CardHeader>
						<CardTitle>Patient Information</CardTitle>
					</CardHeader>
					<CardContent>
						<PatientForm onSuccess={handleSuccess} />
					</CardContent>
				</Card>
			</Container>
		</Page>
	)
}
